import script from "./status.vue?vue&type=script&setup=true&lang=js"
export * from "./status.vue?vue&type=script&setup=true&lang=js"

import "./status.vue?vue&type=style&index=0&id=602582bc&lang=less&scoped=true"

import exportComponent from "/home/opt/gitlab-runner/web_artemisads_repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-602582bc"]])

export default __exports__